import React, { useState, useEffect } from "react";
import PackageCard from "../components/PackageCard";
import toast, { Toaster } from "react-hot-toast";
import { Wallet } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
const Packages = () => {
  const [duration, setDuration] = useState("3-Month");
  const [wallet, setWallet] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // Extra Benefits logic from URS
  const getExtraBenefits = (dur) => {
    switch (dur) {
      case "3-Month": return "18% flat discount on other products";
      case "6-Month": return "22% flat discount on other products";
      case "12-Month": return "25% flat discount on other products";
      default: return "Standard pricing (No flat discount)";
    }
  };

  const subscriptionData = [
    {
      name: "Starter",
      description: "Ideal for light needs or those just starting their journey.",
      popular: false,
      plans: {
      
        "3-Month": { price: "259.99", pads: 20, rate: "₹13/pad" },
        "6-Month": { price: "459.99", pads: 40, rate: "₹11.5/pad" },
        "12-Month": { price: "839.99", pads: 80, rate: "₹10.5/pad" },
      }
    },
    {
      name: "Essential",
      description: "Balanced care for your regular monthly cycle.",
      popular: false,
      plans: {
        
        "3-Month": { price: "389.99", pads: 30, rate: "₹13/pad" },
        "6-Month": { price: "689.99", pads: 60, rate: "₹11.5/pad" },
        "12-Month": { price: "1,259.99", pads: 120, rate: "₹10.5/pad" },
      }
    },
    {
      name: "Popular",
      description: "Our most requested tier for complete peace of mind.",
      popular: true,
      plans: {
    
        "3-Month": { price: "584.99", pads: 45, rate: "₹13/pad" },
        "6-Month": { price: "1,034.99", pads: 90, rate: "₹11.5/pad" },
        "12-Month": { price: "1,889.99", pads: 180, rate: "₹10.5/pad" },
      }
    },
    {
      name: "Premium",
      description: "Maximum protection and ultimate convenience.",
      popular: false,
      plans: {
        
        "3-Month": { price: "779.99", pads: 60, rate: "₹13/pad" },
        "6-Month": { price: "1,378.99", pads: 120, rate: "₹11.5/pad" },
        "12-Month": { price: "2,519.99", pads: 240, rate: "₹10.5/pad" },
      }
    }
  ];

  const handleSubscribe = (plan) => {
    setWallet((prev) => [...prev, { ...plan, id: Date.now() }]);
    
    
        toast.custom((t) => (
      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5 }}
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full bg-white shadow-2xl rounded-[1.5rem] pointer-events-auto flex ring-1 ring-black ring-opacity-5 overflow-hidden border-b-4 border-rose-500`}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              {/* <img className="h-12 w-12 rounded-xl object-cover" src={product.images[0]} alt="" /> */}
            </div>
            <div className="ml-3 flex-1">
              <p className="text-sm font-bold text-rose-950">Added to your care box!</p>
              <p className="mt-1 text-xs text-rose-900/50 font-medium">{plan.name} has been saved.</p>
            </div>
          </div>
        </div>
        <div className="flex border-l border-rose-50">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-bold text-rose-600 hover:text-rose-500 focus:outline-none"
          >
            Close
          </button>
        </div>
      </motion.div>
    ), { duration: 3000 });
  };

  return (
    <div className="min-h-screen bg-[#FFF5F7] p-6 lg:p-12 font-sans text-gray-900">
      <Toaster position="bottom-center" reverseOrder={false} />
      
      <div className="max-w-7xl mx-auto">
        {/* <header className="flex flex-col md:flex-row justify-between items-center mb-12"> */}
         <div className="text-center mb-8">
             <h1 className="text-4xl font-extrabold mb-4 text-pink-800 tracking-tight">Your Period, Simplified</h1>
          <p className="text-gray-600 text-lg mb-8">Choose a plan that fits your flow and your budget.</p>
 </div>
          
          {/* <div className="mt-6 md:mt-0 flex items-center gap-4 bg-white p-4 rounded-2xl shadow-sm border border-pink-100">
            <Wallet className="text-pink-500 w-8 h-8" />
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase">Wallet Items</p>
              <p className="text-xl font-black text-pink-600">{wallet.length} Subscriptions</p>
            </div>
          </div> */}
        {/* </header> */}

        {/* Four Durations Switcher */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex p-1.5 bg-pink-100 rounded-2xl">
            {["3-Month", "6-Month", "12-Month"].map((d) => (
              <button
                key={d}
                onClick={() => setDuration(d)}
                className={`px-6 py-2 rounded-xl text-sm font-bold transition-all ${
                  duration === d 
                  ? "bg-pink-500 text-white shadow-lg" 
                  : "text-pink-600 hover:bg-pink-50"
                }`}
              >
                {d}
              </button>
            ))}
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {subscriptionData.map((tier, index) => (
            <PackageCard 
              key={index}
              name={tier.name}
              popular={tier.popular}
              description={tier.description}
              duration={duration}
              price={tier.plans[duration].price}
              rate={tier.plans[duration].rate}
              padCount={`${tier.plans[duration].pads} Pads Total`}
              onSubscribe={() => handleSubscribe({
                name: tier.name,
                price: tier.plans[duration].price,
                duration: duration
              })}
              features={[
                "Premium Eveya Leaf Pads",
                getExtraBenefits(duration),
               
                "Priority Delivery"
              ]}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Packages;